import axios from "axios";
import { adminSlice } from "../reducers/AdminSlice";
import { AppDispatch } from "../Store";
import {
  GET_ALL_MESSAGES_BY_TICKET_ID,
  GET_COMMON_STATS,
  GET_OPERATOR_STATS,
  GET_TICKET_BY_ID,
  GET_TICKETS_SEARCH,
  GET_ALL_TICKETS,
} from "./endpoints";
import { ticketSlice } from "../reducers/TicketSlice";
import userEvent from "@testing-library/user-event";

export const getCommonStats =
  (fromDate?: string, toDate?: string) => async (dispatch: AppDispatch) => {
    try {
      dispatch(adminSlice.actions.getCommonStatsLoading());

      const res = await axios.get(GET_COMMON_STATS, {
        withCredentials: true,
        params: {
          fromDate,
          toDate,
        },
      });

      dispatch(adminSlice.actions.getCommonStatsSuccess(res.data));
    } catch (error: any) {
      dispatch(adminSlice.actions.getCommonStatsFailed(error.message));
    }
  };

export const getOperatorStats =
  (operatorId: string, fromDate?: string, toDate?: string) =>
  async (dispatch: AppDispatch) => {
    try {
      dispatch(adminSlice.actions.getOperatorStatsLoading());
      const res = await axios.get(
        GET_OPERATOR_STATS +
          `?operatorId=${operatorId}${fromDate ? `&fromDate=${fromDate}` : ""}${
            toDate ? `&toDate=${toDate}` : ""
          }`,
        { withCredentials: true }
      );
      dispatch(adminSlice.actions.getOperatorStatsSuccess(res.data));
    } catch (error: any) {
      dispatch(adminSlice.actions.getOperatorStatsFailed(error.message));
    }
  };

export const getTicketBySearch =
  (search: string) => async (dispatch: AppDispatch) => {
    try {
      dispatch(adminSlice.actions.getTicketBySearchLoading());
      const res = await axios.get(GET_TICKETS_SEARCH + `?search=${search}`, {
        withCredentials: true,
      });
      dispatch(adminSlice.actions.getTicketBySearchSuccess(res.data));
    } catch (error: any) {
      dispatch(adminSlice.actions.getTicketBySearchFailed(error.message));
    }
  };

export const adminGetTicketById =
  (ticketId: number) => async (dispatch: AppDispatch) => {
    try {
      dispatch(adminSlice.actions.getTicketBySearchLoading());

      const res = await axios.get(GET_TICKET_BY_ID + `?id=${ticketId}`, {
        withCredentials: true,
      });

      dispatch(adminSlice.actions.getTicketBySearchSuccess([res.data]));
    } catch (error: any) {
      dispatch(adminSlice.actions.getTicketBySearchFailed(error.message));
    }
  };

export const adminGetMessageByTicketId =
  (ticketId: number) => async (dispatch: AppDispatch) => {
    try {
      dispatch(adminSlice.actions.getMessageByTicketLoading());

      const res = await axios.get(
        GET_ALL_MESSAGES_BY_TICKET_ID + `?ticketId=${ticketId}`,
        { withCredentials: true }
      );

      dispatch(adminSlice.actions.getMessageByTicketSuccess(res.data));
    } catch (error: any) {
      dispatch(adminSlice.actions.getMessageByTicketFailed(error.message));
    }
  };

export const getAllTickets = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(ticketSlice.actions.getAllTicketsLoading());
    const res = await axios.get(GET_ALL_TICKETS, { withCredentials: true });
    dispatch(ticketSlice.actions.getAllTicketsSuccess(res.data));
  } catch (error: any) {
    dispatch(ticketSlice.actions.getAllTicketsFailed(error.message));
  }
};
